import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus } from '../../../../util/util';
import { OutTable, ExcelRenderer } from 'react-excel-renderer';
import { Alert, AlertCommit } from '../../../Modals/AlertBar';
import Select from 'react-select';
import map from 'lodash/map';
import ExportExcelDriver from '../ExportExcel/ExportExcelDriver';


class ImportExportDriver extends Component {
    constructor() {
        super();
        this.state = {
            cols:[],
            rows:[],
            objExcelList: [],
            driverList: []
        }
    }

    getDriverList() {
        // const { currentPageSize, driverSearch } = this.state;
        const { token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getDriverList/1/9999`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({ driverList: data.RESULT_DATA })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    onChageFile = (e) => {
        let fileObj = e.target.files[0];
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if(err){
                console.log('err:', err);
                Alert('รูปแบบไฟล์ไม่ถูกต้อง กรุณาเลือกเฉพาะไฟล์ Excel​')
            }
            else{
                this.setState({
                    cols: resp.cols,
                    rows: resp.rows
                },() => this.validateData());
            }
        });
    }

    validateData = () => {
        const { cols, rows } = this.state;
        let objList = [];
        if (cols.length !== 15) {
            Alert('รูปแบบไฟล์ไม่ถูกต้อง')
        } else {
            for (let i = 1; i < rows.length; i++)
                objList.push({
                    prefix: rows[i][0],
                    first_name: rows[i][1],
                    last_name: rows[i][2],
                    gender: rows[i][3],
                    telephone: rows[i][4],
                    birthday: rows[i][5],
                    card_number: rows[i][6],
                    card_registrar: rows[i][7],
                    card_nation: rows[i][8],
                    license_type: rows[i][9],
                    license_gov: rows[i][10],
                    license_number: rows[i][11],
                    license_start: rows[i][12],
                    license_expire: rows[i][13],
                    note: rows[i][14]
                })
        }
        this.setState({objExcelList: objList});
    }

    onSubmitUpload = () => {
        const { objExcelList } = this.state;
        const { user_id, user_name, token } = this.props;
        if (objExcelList && objExcelList.length > 0) {
            fetch(`http://203.150.199.244/api/admin/newManyDriver`, {
                method: 'post',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    // "user_id": user_id,
                    // "user_name": user_name,
                    "token": token
                },
                body: JSON.stringify(objExcelList)
            })
                .then(response => { return checkStatus(response)})
                .then(data => {
                    if (data.RESULT_MESSAGE === 'Successfull') {
                        AlertCommit('อัพโหลดสำเร็จ');
                    } else {
                        Alert('ข้อมูลผิดพลาด กรุณาอัพโหลดใหม่');
                    }
                })
        }

    }

    handleClickDownloadTemplate = () => {
        const value = require('../../../../../downloads/uploadEmployeeTemplate.xlsx');
        window.location = value;
    }

  render() {
      const { driverList } = this.state;
      const { t } = this.props;
    return (
        <div>

           <div className="container">
           <div className="row">
        <div className="card" style={{width:'100%'}}>
            <div className="card-header">
                <strong>{t('ส่งออกข้อมูล')}</strong>
            </div>
            <div className="card-body">
                <div className="form-group row">
                    <div className="col-md-2">
                        <button onClick={() => this.getDriverList()} type="submit" className="btn btn-primary">{t('บันทึกข้อมูล')}</button>
                    </div>
                    {driverList && driverList.length > 0 &&
                    <ExportExcelDriver dataExcel={driverList} />
                    }
                </div>
            </div>
        </div>
        </div>
<br/>
        <div className="row">
            <div className="card" style={{width:'100%'}}>
                    <div className="card-header">
                        <strong>{t('นำเข้าข้อมูล')}</strong>
                    </div>
                    <div className="card-body">
                        <div className="form-group row">
                            <label htmlFor="upload" className="col-md-2">XLSX File
                            </label>
                            <div className="col-md-10">
                                <input onChange={e => this.onChageFile(e)} className="form-control" style={{opacity: 1}} type="file" id="upload" accept=".xlsx, .xls" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-md-2">
                                <button onClick={() => this.onSubmitUpload()} type="submit" className="btn btn-primary">{t('บันทึกข้อมูล')}</button>
                            </div>
                            <div className="col-md-2">
                                <button onClick={() => this.handleClickDownloadTemplate()} className="btn btn-primary">{t('ดาวน์โหลดแม่แบบ')}</button>
                            </div>

                        </div>
                    </div>
            </div>
        </div>
        <br/>

           </div>

</div>
    );
  }
}

ImportExportDriver.propTypes = {
    t: PropTypes.func.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired
}

export default ImportExportDriver;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/ImportExportDriver.js